import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './pages/Home'
import SignIn from './pages/SignIn'
import ResetPassword from './pages/ResetPassword'
import Products from './pages/user/inventory/products/Products'
import ProductDetail from './pages/user/inventory/products/ProductDetail'
import GeneratePictureFile from './pages/user/inventory/picturefile/GeneratePictureFile'
import Categories from './pages/user/inventory/categories/categories'
import Attributes from './pages/user/inventory/attributes/attributes'
import QuantityUpdate from './pages/user/inventory/quantityupdate/UpdateQuantity'
import Invoices from './pages/user/orders/Invoices'
import SalesOrders from './pages/user/orders/SalesOrders'
import SalesOrdersCreate from './pages/user/orders/SalesOrdersCreate'
import SalesOrderDetail from './pages/user/orders/SalesOrderDetail'
import Bills from './pages/user/purchasing/bills/Bills'
import BillsCreate from './pages/user/purchasing/bills/BillsCreate'
import BillsDetail from './pages/user/purchasing/bills/BillsDetail'
import StockTransfer from './pages/user/warehousing/stocktransfer/StockTransfer'
import StockTransferCreate from './pages/user/warehousing/stocktransfer/StockTransferCreate'
import LabelGenerator from './pages/user/warehousing/labelgenerator/LabelGenerator'
import BatchPick from './pages/user/warehousing/batchpick/BatchPick'
import Customers from './pages/user/lists/customers/Customers'
import CustomerDetail from './pages/user/lists/customers/CustomerDetail'
import Vendors from './pages/user/lists/vendors/Vendors'
import VendorDetail from './pages/user/lists/vendors/VendorDetail'
import TransactionLedger from './pages/user/reporting/TransactionLedger'
import UserManagement from './pages/admin/company/UserManagement'
import CompanyBranding from './pages/admin/company/CompanyBranding'
import SalesReps from './pages/admin/company/SalesReps'
import PaymentDepositAccounts from './pages/admin/company/PaymentDepositAccounts'
import PaymentTerms from './pages/admin/company/PaymentTerms'
import ShippingMethods from './pages/admin/company/ShippingMethods'
import PaymentMethods from './pages/admin/company/PaymentMethods'
import Locations from './pages/admin/company/Locations'
import Logs from './pages/admin/company/Logs'
import SourceManagement from './pages/admin/company/SourceManagement'
import CustomerSignUp from './pages/registration/CustomerSignUp'
import CustomerSignUpReview from './pages/user/lists/customers/CustomerSignUpReview'
import Payments from './pages/user/accounting/payments/Payments'
import Credits from './pages/user/orders/Credits'
import CreditsCreate from './pages/user/orders/CreditsCreate'
import CreditsDetail from './pages/user/orders/CreditsDetail'
import store from './store'
import { AbilityBuilder } from '@casl/ability'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/sign-up',
        name: 'CustomerSignUp',
        component: CustomerSignUp
    },
    {
        path: '/signin',
        name: 'SignIn',
        component: SignIn
    },
    {
        path: '/passwordreset/:details',
        name: 'ResetPassword',
        component: ResetPassword
    },
    {
        path: '/inventory/products',
        name: 'Products',
        component: Products,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-products' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/inventory/products/details/:sku',
        name: 'ProductDetail',
        component: ProductDetail,
        props: true,
        async beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-product-details' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/inventory/generate-picture-file',
        name: 'GeneratePictureFile',
        component: GeneratePictureFile,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-generate-picture-file' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/inventory/categories',
        name: 'Categories',
        component: Categories,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-categories' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/inventory/attributes',
        name: 'Attributes',
        component: Attributes,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-attributes' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/inventory/quantity-update',
        name: 'QuantityUpdate',
        component: QuantityUpdate,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-quantity-update' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/orders/invoices',
        name: 'Invoices',
        component: Invoices,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-invoices' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/orders/sales-orders/:status?',
        name: 'SalesOrders',
        component: SalesOrders,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-sales-orders' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/orders/sales-orders/create/:customerId?',
        name: 'SalesOrdersCreate',
        component: SalesOrdersCreate,
        props: true,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-sales-order-create' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/orders/sales-orders/details/:soNum',
        name: 'SalesOrderDetail',
        component: SalesOrderDetail,
        props: true,
        async beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-sales-order-details' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/purchasing/bills',
        name: 'Bills',
        component: Bills,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-bills' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/purchasing/bills/create',
        name: 'BillsCreate',
        component: BillsCreate,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'create-bills' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/purchasing/bills/details/:billNum',
        name: 'BillsDetail',
        component: BillsDetail,
        props: true,
        async beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-bills-details' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/reporting/transaction-ledger',
        name: 'TransactionLedger',
        component: TransactionLedger,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-transaction-ledger' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/warehousing/stock-transfer',
        name: 'StockTransfer',
        component: StockTransfer,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-stock-transfer' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/warehousing/stock-transfer/create',
        name: 'StockTransferCreate',
        component: StockTransferCreate,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-stock-transfer' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/warehousing/label-generator',
        name: 'LabelGenerator',
        component: LabelGenerator,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-label-generator' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/warehousing/batch-pick',
        name: 'BatchPick',
        component: BatchPick,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-batch-pick' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/lists/customers',
        name: 'Customers',
        component: Customers,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-customers' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/lists/customers/details/:id',
        name: 'CustomerDetail',
        component: CustomerDetail,
        props: true,
        async beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-customer-detail' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/lists/customers/review',
        name: 'CustomerSignUpReview',
        component: CustomerSignUpReview,
        props: true,
        async beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-customer-review' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/lists/vendors',
        name: 'Vendors',
        component: Vendors,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-vendors' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/lists/vendors/details/:id',
        name: 'VendorDetail',
        component: VendorDetail,
        props: true,
        async beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-vendor-detail' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/accounting/payments',
        name: 'Payments',
        component: Payments,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-payments' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/orders/creditmemos',
        name: 'Credits',
        component: Credits,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-credits' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/orders/creditmemos/create/:customerId?',
        name: 'CreditsCreate',
        component: CreditsCreate,
        props: true,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-credits-create' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/orders/creditmemos/details/:creditNum',
        name: 'CreditsDetail',
        component: CreditsDetail,
        props: true,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-credits-edit' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/company/user-management',
        name: 'UserManagement',
        component: UserManagement,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-user-management' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/company/branding',
        name: 'CompanyBranding',
        component: CompanyBranding,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-company-branding' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/company/sales-reps',
        name: 'SalesReps',
        component: SalesReps,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/company/payment-terms',
        name: 'PaymentTerms',
        component: PaymentTerms,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/company/payment-methods',
        name: 'ReceivePaymentMethods',
        component: PaymentMethods,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/company/shipping-methods',
        name: 'ShippingMethods',
        component: ShippingMethods,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/company/locations',
        name: 'Locations',
        component: Locations,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/company/payment-deposit-accounts',
        name: 'PaymentDepositAccounts',
        component: PaymentDepositAccounts,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/company/logs',
        name: 'Logs',
        component: Logs,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    },
    {
        path: '/company/source-management',
        name: 'SourceManagement',
        component: SourceManagement,
        beforeEnter(to, from, next) {
            let arr = store.state.auth.abilities
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].name === 'view-source-management' || arr[i].name == 'view-all') {
                    next()

                    return
                }
            }

            next({ name: 'Home' })
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    // scrollBehavior (to, from, savedPosition) {
    //     return new Promise((resolve, reject) => {
    //         setTimeout(() => {
    //             if (savedPosition) {
    //                 console.log('here')
    //                 resolve({ savedPosition })
    //             } else {
    //                 console.log('0')
    //                 resolve({ x: 0, y: 0 })
    //             }
    //         }, 500)
    //     })

    //     // if (savedPosition) {
    //     //     return new Promise((resolve, reject) => {
    //     //         setTimeout(() => {
    //     //             resolve({ savedPosition })
    //     //         }, 100)
    //     //     })
    //     //     // return savedPosition
    //     // } else {
    //     //     return new Promise((resolve, reject) => {
    //     //         setTimeout(() => {
    //     //             resolve({ x: 0, y: 0 })
    //     //         }, 100)
    //     //     })
    //     //     // return { x: 0, y: 0 }
    //     // }
    // }
})

export default router
